__turbopack_context__.v({
  "DM_12_24_Link_B": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_12_24_Link_B",
  "DM_14_24_Link_B": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_14_24_Link_B",
  "DM_20_24_Bold": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_20_24_Bold",
  "DM_Body_Reg_16": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Body_Reg_16",
  "DM_Bold_14_16": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Bold_16_24",
  "DM_Bold_20_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Bold_20_24",
  "DM_Bold_40_56": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Btn_16_16_Med",
  "DM_Med_10_12": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_10_12",
  "DM_Med_12_12_Chip": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_12_12_Chip",
  "DM_Med_12_16": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_12_16",
  "DM_Med_14_16": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_14_16",
  "DM_Med_14_20": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_14_20",
  "DM_Med_14_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_14_24",
  "DM_Med_16_16": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_16_16",
  "DM_Med_16_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_16_24",
  "DM_Med_18_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_18_24",
  "DM_Med_20_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_20_24",
  "DM_Med_24_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_24_24",
  "DM_Med_32_32": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_32_32",
  "DM_Med_32_48": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_32_48",
  "DM_Med_8_8": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Med_8_8",
  "DM_Reg_10_10": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_12_16",
  "DM_Reg_14_16": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_14_16",
  "DM_Reg_14_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_16_20",
  "DM_Reg_16_24": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_18_28",
  "DM_Reg_32_32": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_32_32",
  "DM_Reg_40_56": "TwoColumnsLayout-module-scss-module__eG7ynG__DM_Reg_40_56",
  "bottomSection": "TwoColumnsLayout-module-scss-module__eG7ynG__bottomSection",
  "container": "TwoColumnsLayout-module-scss-module__eG7ynG__container",
  "content": "TwoColumnsLayout-module-scss-module__eG7ynG__content",
  "header": "TwoColumnsLayout-module-scss-module__eG7ynG__header",
  "languageSelect": "TwoColumnsLayout-module-scss-module__eG7ynG__languageSelect",
  "leftColumn": "TwoColumnsLayout-module-scss-module__eG7ynG__leftColumn",
  "link": "TwoColumnsLayout-module-scss-module__eG7ynG__link",
  "linkWrapper": "TwoColumnsLayout-module-scss-module__eG7ynG__linkWrapper",
  "logo": "TwoColumnsLayout-module-scss-module__eG7ynG__logo",
  "logoWrapper": "TwoColumnsLayout-module-scss-module__eG7ynG__logoWrapper",
  "rightColumn": "TwoColumnsLayout-module-scss-module__eG7ynG__rightColumn",
  "showcase": "TwoColumnsLayout-module-scss-module__eG7ynG__showcase",
  "showcaseWrapper": "TwoColumnsLayout-module-scss-module__eG7ynG__showcaseWrapper",
  "tabletLogo": "TwoColumnsLayout-module-scss-module__eG7ynG__tabletLogo",
});
